// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"139":"343a771adf1159b8","247":"884912bda9c95153"}[chunkId] + ".js";
};